<script setup lang="ts">
import type { ShortcutJs } from "@/generated/models";
import { useFileIcon } from "./fileIcon";

const props = defineProps<{
  file: ShortcutJs;
}>();

const icon = useFileIcon(() => props.file);
</script>

<template>
  <component :is="icon" aria-hidden="true" />
</template>
